import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter, Route } from 'react-router-dom';
import SearchSuggestions from '../search/buyer-search-suggestions/SearchSuggestions';

if (document.getElementById('search-input')) {
  ReactDOM.render(
    <BrowserRouter>
      <Route path="/" component={SearchSuggestions} />
    </BrowserRouter>,
    document.getElementById('search-input'),
  );
}
